import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { BookingErrorModal } from "./component";
import {
  getErrorTitles,
  getPriceDifference,
  getHasError,
  getIsMissingPassport,
  getSchedulePaymentCallState,
  getFlightBookType,
  getInfantOnlyError,
  getPriceQuoteWithUpdatedAncillary,
  getSeatMapAvailability,
  getUserSelectedLapInfantIds,
  getUserSelectedPassengerIds,
  getSession,
  getPaymentsV2,
  getAncillaries,
  getBookingProgressList,
  getModalEventType,
} from "../../reducer";
import {
  acknowledgePriceDifference,
  scheduleQuote,
  schedulePayment,
  resetBookingErrors,
  setUpFlightBookParams,
  setInfantOnlyError,
  setUserSelectedPassengerIds,
  setUserSelectedLapInfantIds,
  resetPaymentCardSelectedAccounts,
} from "../../actions/actions";
import {
  populateFlightShopQueryParams,
  resetSelectedTrip,
} from "../../../shop/actions/actions";
import {
  getViewedTripSummaryProperties,
  isFlightBookWithAncillariesActiveSelector,
} from "../../../shop/reducer";
import { getTripCategory } from "../../../search/reducer";
import { IStoreState } from "../../../../reducers/types";

const mapStateToProps = (state: IStoreState) => ({
  bookingProgressList: getBookingProgressList(state),
  priceDifference: getPriceDifference(state),
  errorTitles: getErrorTitles(state),
  hasError: getHasError(state),
  currentSession: getSession(state),
  payments: getPaymentsV2(state),
  ancillaries: getAncillaries(state),
  isMissingPassport: getIsMissingPassport(state),
  modalType: getModalEventType(state),
  schedulePaymentCallState: getSchedulePaymentCallState(state),
  viewedTripSummaryProperties: getViewedTripSummaryProperties(state),
  fightBookType: getFlightBookType(state),
  infantOnlyError: getInfantOnlyError(state),
  priceQuote: getPriceQuoteWithUpdatedAncillary(state),
  seatMapAvailability: getSeatMapAvailability(state),
  selectedLapInfantIds: getUserSelectedLapInfantIds(state),
  selectedPaxIds: getUserSelectedPassengerIds(state),
  isFlightBookWithAncillariesActive:
    isFlightBookWithAncillariesActiveSelector(state),
  tripCategory: getTripCategory(state),
});

const mapDispatchToProps = {
  acknowledgePriceDifference,
  populateFlightShopQueryParams,
  scheduleQuote,
  schedulePayment,
  resetBookingErrors,
  resetSelectedTrip,
  setUpFlightBookParams,
  setInfantOnlyError,
  setUserSelectedPassengerIds,
  setUserSelectedLapInfantIds,
  resetPaymentCardSelectedAccounts,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type BookingErrorModalConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedBookingErrorModal = withRouter(
  connector(BookingErrorModal),
);
